export default __webpack_public_path__ + "static/media/ads.deb92605.svg";